import { useGet } from '@/lib/hooks/useFetch';
import { AxiosApiError } from '@/lib/config/types';
import { SettingsResponse, VoiceSettings } from './types';

interface UseSettingsOptions {
  enabled?: boolean;
}

/**
 * Hook para buscar as configurações do usuário (incluindo XMPP)
 * Equivalente ao SettingsService.load() do smartspace-fe
 * Endpoint: /api-gateway/v1/account/settings
 * 
 * @param options.enabled - Se false, a requisição não será feita (para usuários externos)
 */
export const useSettings = ({ enabled = true }: UseSettingsOptions = {}) => {
  return useGet<SettingsResponse, AxiosApiError>({
    key: ['account-settings'],
    url: 'account/settings',
    apiType: 'api',
    options: {
      enabled,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  });
};

/**
 * Hook para buscar apenas as configurações de voz/XMPP
 * 
 * @param options.enabled - Se false, a requisição não será feita (para usuários externos)
 */
export const useVoiceSettings = ({ enabled = true }: UseSettingsOptions = {}) => {
  const { data, ...rest } = useSettings({ enabled });
  return {
    data: data?.settings?.voice,
    ...rest,
  };
};

export * from './types';
